// Records a validated access code per group (sessionStorage, keyed by slug) so the
// stepper stays gated. Only the code + label are stored — no agentId, so nothing
// routing-sensitive lives in the browser.

const keyFor = (slug: string) => `enroll:access:${slug}`;

export interface EnrollAccess {
  accessCode: string;
  label: string;
  validatedAt: string;
}

export function getEnrollAccess(slug: string): EnrollAccess | null {
  try {
    const raw = sessionStorage.getItem(keyFor(slug));
    return raw ? (JSON.parse(raw) as EnrollAccess) : null;
  } catch {
    return null;
  }
}

export function setEnrollAccess(slug: string, access: EnrollAccess): void {
  try {
    sessionStorage.setItem(keyFor(slug), JSON.stringify(access));
  } catch {
    // sessionStorage unavailable (private mode) — the gate just won't persist.
  }
}

export function clearEnrollAccess(slug: string): void {
  try {
    sessionStorage.removeItem(keyFor(slug));
  } catch {
    // ignore
  }
}
